export default {
  name: "sort-by",

  data() {
    return {
      isShowDropdown: false,
      type: "desc"
    };
  },

  watch: {
    type(newType) {
      this.sortingProperties(newType);
    }
  },

  props: {
    sortBy: {
      default: 'newest'
    },
    sortOrder: {
      default: 'desc'
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.sortOrder === 'desc')
        return;
      this.isShowDropdown = true;
      if (this.type === 'newest')
        this.type = this.sortBy;
      else
        this.type = this.sortOrder;
    });
  },

  methods: {
    toggleSortList() {
      this.isShowDropdown = !this.isShowDropdown;
    },

    sortingProperties(type) {
      if (!type)
        return this.type = this.sortBy;
      this.isShowDropdown = !this.isShowDropdown;
      this.$emit("triggerChangeSorting", type);
    },

    hideDropdown() {
      this.isShowDropdown = false;
    }
  },

  components: {}
};
